import { useState } from "react"

export default function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [password, setPassword] = useState("")

  const correctPassword = process.env.REACT_APP_SITE_PASSWORD

  const handleSubmit = (e) => {
    e.preventDefault()
    if (password === correctPassword) {
      setIsAuthenticated(true)
    } else {
      alert("Wrong password!")
    }
  }

  if (!isAuthenticated) {
    return (
      <div style={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f5f5"
      }}>
        <form onSubmit={handleSubmit} style={{
          padding: "2rem",
          borderRadius: "10px",
          background: "white",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
        }}>
          <h2 style={{ marginBottom: "1rem", textAlign: "center" }}>Enter Password</h2>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: "100%", padding: "10px", marginBottom: "1rem", borderRadius: "5px", border: "1px solid #ccc" }}
          />
          <button
            type="submit"
            style={{ width: "100%", padding: "10px", borderRadius: "5px", background: "#1e7e34", color: "white", fontWeight: "bold", border: "none" }}
          >
            Unlock
          </button>
        </form>
      </div>
    )
  }

  return children
}
